import {DisabilityProfileLetter, ProjectExtended} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'
import {Helmet} from 'react-helmet'
import {useOutletContext} from 'react-router-dom'
import {StyledDisabilityProfile} from './style'
import {useState} from 'react'
import {DisabilityProfileLetterB} from '@/features/projects/components/disability-profile-letter-b/DisabilityProfileLetterB'
import {DisabilityProfileLetterS} from '@/features/projects/components/disability-profile-letter-s/DisabilityProfileLetterS'
import {DisabilityProfileLetterD} from '@/features/projects/components/disability-profile-letter-d/DisabilityProfileLetterD'
import {DisabilityProfileLetterE} from '@/features/projects/components/disability-profile-letter-e/DisabilityProfileLetterE'

export const ProjectDetailsDisabilityProfile = () => {
    const {t} = useTranslation()
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const [editingLetter, setEditingLetter] = useState<DisabilityProfileLetter | null>(null)

    return (
        <StyledDisabilityProfile>
            <Helmet title={t('commons:fullname_details_meta_title', {fullName: project.patient.fullName})} />
            <DisabilityProfileLetterB
                editingLetter={editingLetter}
                setEditingLetter={setEditingLetter}
                projectId={project.id}
                defaultValues={project.disabilityProfiles
                    .filter(profile => profile.letter == 'b')
                    .map(profile => ({
                        icfCode: profile.icfCode.code,
                        qualifier1: profile.qualifier1 ? profile.qualifier1.toString() : undefined
                    }))}
            />
            <DisabilityProfileLetterS
                editingLetter={editingLetter}
                setEditingLetter={setEditingLetter}
                projectId={project.id}
                defaultValues={project.disabilityProfiles
                    .filter(profile => profile.letter == 's')
                    .map(profile => ({
                        icfCode: profile.icfCode.code,
                        qualifier1: profile.qualifier1 ? profile.qualifier1.toString() : undefined,
                        qualifier2: profile.qualifier2 ? profile.qualifier2.toString() : undefined
                    }))}
            />
            <DisabilityProfileLetterD
                editingLetter={editingLetter}
                setEditingLetter={setEditingLetter}
                projectId={project.id}
                defaultValues={project.disabilityProfiles
                    .filter(profile => profile.letter == 'd')
                    .map(profile => ({
                        icfCode: profile.icfCode.code,
                        qualifier1: profile.qualifier1 ? profile.qualifier1.toString() : undefined,
                        qualifier2: profile.qualifier2 ? profile.qualifier2.toString() : undefined
                    }))}
            />
            <DisabilityProfileLetterE
                editingLetter={editingLetter}
                setEditingLetter={setEditingLetter}
                projectId={project.id}
                defaultValues={project.disabilityProfiles
                    .filter(profile => profile.letter == 'e')
                    .map(profile => ({
                        icfCode: profile.icfCode.code,
                        qualifier1: profile.qualifier1 ? profile.qualifier1.toString() : undefined,
                        qualifier2: profile.qualifier2 ? profile.qualifier2.toString() : undefined,
                        type: profile.type ?? null
                    }))}
            />
        </StyledDisabilityProfile>
    )
}
